import { C_WHLOC_COOKIE, C_WHLOC_COOKIE_EXPIRES_DAYS } from "../../constants/cookies.js";
import Cookie from "js-cookie";
import { useAgent } from "../../utils/agent/AgentProvider.js";
import { orderCookie } from "../../utils/index.js";
import { useRef, useEffect, useCallback } from "react";
import "../../components/Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../components/Chrome/BrowseContext/hook.js";
const useUpdatePreferredWarehouse = () => {
  const { userLocation, warehouse } = useBrowseContext();
  const { agent } = useAgent();
  const userLocationRef = useRef(userLocation);
  const warehouseRef = useRef(warehouse);
  const isMounted = useRef(false);
  useEffect(() => {
    if (isMounted.current) {
      userLocationRef.current = userLocation;
      warehouseRef.current = warehouse;
    } else {
      isMounted.current = true;
    }
  }, [userLocation, warehouse]);
  const updatePreferredWarehouse = useCallback(
    ({
      city,
      countryCode,
      postalCode,
      territory,
      warehouseId,
      warehouseDrawer,
      itemType,
      pageName,
      orderItemId,
      shouldUpdateCookies
    }) => {
      try {
        if (agent) {
          agent.getCheckoutWarehouse(
            warehouseId,
            warehouseDrawer,
            itemType ? itemType : null,
            pageName ? pageName : null,
            orderItemId ? orderItemId : null
          );
        }
      } catch {
        return false;
      }
      if (warehouseDrawer === "FMW" || shouldUpdateCookies) {
        const warehouseCatalog = `${warehouseId}-wh`;
        const updatedWarehouse = warehouseRef.current.nearestWarehouse ? { ...warehouseRef.current } : {
          nearestWarehouse: {
            catalog: warehouseCatalog
          }
        };
        const updatedUserLocation = userLocationRef.current.city && userLocationRef.current.zip ? { ...userLocationRef.current } : {
          city,
          zip: postalCode
        };
        updatedUserLocation.zip = postalCode;
        updatedUserLocation.city = city;
        if (!updatedWarehouse.nearestWarehouse) {
          updatedWarehouse.nearestWarehouse = {};
        }
        updatedWarehouse.nearestWarehouse.catalog = warehouseCatalog;
        const orderedUpdatedWarehouse = orderCookie(updatedWarehouse);
        const orderedUpdatedUserLocation = orderCookie(
          updatedUserLocation
        );
        warehouseRef.current.updateWarehouse(orderedUpdatedWarehouse);
        userLocationRef.current.updateUserLocation(
          orderedUpdatedUserLocation
        );
      }
      if (countryCode && territory) {
        const cWhlocCookieValue = `${countryCode}${territory}`;
        Cookie.set(C_WHLOC_COOKIE, cWhlocCookieValue, {
          expires: C_WHLOC_COOKIE_EXPIRES_DAYS
        });
      }
      return true;
    },
    [agent]
  );
  return updatePreferredWarehouse;
};
export {
  useUpdatePreferredWarehouse
};
